<template>
  <div class="white pa-3" style="border-radius: 4px">
    <!-- <h1 class="title" :class="{'mb-3': content, 'mb-4': !content}">{{title}}</h1> -->
    <VueMarkdown
      v-if="title"
      class="title mb-3"
      :source="title"
      :html="false"
      :xhtml-out="true"
      :breaks="true"
      :anchor-attributes="{ target: '_blank' }"
    />

    <!-- <div style="color: rgba(0, 0, 0, 0.35)" class="body-1 mb-3" v-if="content"></div> -->
    <VueMarkdown
      v-if="content"
      class="body-1 mb-3 translucid"
      :source="content"
      :html="false"
      :xhtml-out="true"
      :breaks="true"
      :anchor-attributes="{ target: '_blank' }"
    />

    <div class="buttons">
      <v-btn
        v-for="button in buttons"
        :key="button.name"
        flat
        :class="button.class"
        style="height: 48px; min-width: initial"
        :disabled="loading"
        :loading="button.showLoading && loading"
        @click="selectButton(button)"
      >
        {{ button.name }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";

export default {
  name: "MaterialDialog",

  components: { VueMarkdown },

  props: {
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
    },
    buttons: {
      type: Array,
      default() {
        return [
          { name: "Cancelar", class: "grey--text" },
          { name: "OK", action: true, class: "green--text" },
        ];
      },
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    selectButton(button) {
      if (!button || button.action === undefined) {
        this.$emit("close");
      } else {
        this.loading = true;
        this.$emit("answer", button.action);
      }
    },
  },
};
</script>

<style scoped>
.buttons {
  height: 48px;
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/MaterialDialog.vue